namespace TabAurous.Production {
    export namespace IssueAgainstWorkOrderService {
        export const baseUrl = 'Production/IssueAgainstWorkOrder';

        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<IssueMaterialItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Production/IssueAgainstWorkOrder/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>IssueAgainstWorkOrderService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
